/**
 * Created by lycheng on 2017/11/23.
 * 用于展示客户案例
 */
import 'babel-polyfill'
import { config } from 'config'

function getCustomerCases () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/example/info',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

export {
  getCustomerCases
}



// WEBPACK FOOTER //
// ./src/js/api/customer-case.js